import { type FC, type HTMLProps } from "react";

interface Props extends HTMLProps<HTMLDivElement> {
    top: number;
    left: number;
    width: number;
    height: number;
}

export const GridPosition: FC<Props> = ({
    top,
    left,
    width,
    height,
    style,
    children,
    ...rest
}) => {
    return (
        <div
            {...rest}
            style={{
                gridColumnStart: left,
                gridColumnEnd  : `span ${width}`,
                gridRowStart   : top,
                gridRowEnd     : `span ${height}`,
                ...(style ?? {}),
            }}
        >
            {children}
        </div>
    );
};
